// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2iLAf","colCheckbox":"styles_colCheckbox__1jqcL"};